import { CODE_SYSTEMS, LOINC_CODES } from '@liza/fhir-utils';
import {
  activeConditionsQuery,
  evidenceQueriesFor,
  latestObservation,
  type ContextResources,
} from '../planner/context';
import type { ProtocolSpec } from '../planner/plan';
import type { ProtocolVariables } from '../planner/types';
import { ckdStageMonitoring } from './ckdStageMonitoring';

/** Binds exactly the variables `CKD_STAGE_CONTEXT_VARIABLES` declares (a test pins the two lists together). */
export const deriveCkdStageVariables = (resources: ContextResources): ProtocolVariables => ({
  '%egfr': { kind: 'resource', value: latestObservation(resources, CODE_SYSTEMS.LOINC, LOINC_CODES.EGFR) },
  '%uacr': {
    kind: 'resource',
    value: latestObservation(resources, CODE_SYSTEMS.LOINC, LOINC_CODES.URINE_ALBUMIN_CREATININE_RATIO),
  },
});

/**
 * The stage-indexed CKD protocol, ready for `planProtocol`. Unlike the ongoing-measurement protocols
 * it needs the patient's own latest eGFR and albuminuria, because which cell of KDIGO's grid they
 * fall in is what decides the cadence.
 */
export const ckdStageMonitoringProtocol: ProtocolSpec = {
  planDefinition: ckdStageMonitoring,
  valueSets: [],
  queries: [activeConditionsQuery, ...evidenceQueriesFor(ckdStageMonitoring)],
  deriveVariables: deriveCkdStageVariables,
};
